import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginPage from "../pages/login/page";
import DashboardPage from "../pages/dashboard/page";
import RegistroPage from "../pages/registro/page";
import Scuba3sPage from "../pages/scuba3s/page";
import HistorialAlertasPage from "../pages/historial-alertas/page";
import AnalisisPage from "../pages/analisis/page";
import ReportesPage from "../pages/reportes/page";
import ConfiguracionPage from "../pages/configuracion/page";
import QuimicosPage from "../pages/quimicos/page";
import InventarioPage from "../pages/inventario/page";
import AdminPage from "../pages/admin/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute requiredPermission="view:dashboard">
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/registro",
    element: (
      <ProtectedRoute requiredPermission="view:registro">
        <RegistroPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/scuba3s",
    element: (
      <ProtectedRoute requiredPermission="view:scuba3s">
        <Scuba3sPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/historial-alertas",
    element: (
      <ProtectedRoute requiredPermission="view:historial-alertas">
        <HistorialAlertasPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/analisis",
    element: (
      <ProtectedRoute requiredPermission="view:analisis">
        <AnalisisPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reportes",
    element: (
      <ProtectedRoute requiredPermission="view:reportes">
        <ReportesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/configuracion",
    element: (
      <ProtectedRoute requiredPermission="view:configuracion">
        <ConfiguracionPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quimicos",
    element: (
      <ProtectedRoute requiredPermission="view:quimicos">
        <QuimicosPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/inventario",
    element: (
      <ProtectedRoute requiredPermission="view:inventario">
        <InventarioPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute requiredPermission="view:admin">
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
